import { useEffect, useState } from "react";

const navItems = [
  { label: "官方入口", href: "#channels" },
  { label: "话题广场", href: "#topics" },
  { label: "最新短讯", href: "#feed" },
  { label: "社区讨论", href: "#discussion" },
  { label: "联系方式", href: "#contact" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5 md:gap-3 cursor-pointer group">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg md:text-xl shrink-0">
            <i className="ri-flashlight-fill"></i>
          </span>
          <h1
            className={`font-heading text-lg md:text-xl font-bold tracking-tight whitespace-nowrap transition-colors ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            黑料官方
          </h1>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3.5 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-100/70"
                  : "text-background-100 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#channels"
            className="hidden sm:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 md:px-5 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-rocket-2-line"></i>
            <span>直达官方入口</span>
          </a>
          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 rounded-md flex items-center justify-center text-xl transition-colors cursor-pointer ${
              solid ? "text-foreground-900 bg-background-100" : "text-background-50 bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50/98 backdrop-blur px-4 py-3">
          <div className="flex flex-wrap gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}